import { render, staticRenderFns } from "./MainPost.vue?vue&type=template&id=1544df64&scoped=true&"
import script from "./MainPost.vue?vue&type=script&lang=js&"
export * from "./MainPost.vue?vue&type=script&lang=js&"
import style0 from "./MainPost.vue?vue&type=style&index=0&id=1544df64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1544df64",
  null
  
)

export default component.exports